<div
  *ngIf="showDocumentSlot"
  class="upload-document-container"
  [class.upload-document-container--no-heading]="hideHeading"
  [class.upload-document-container--compact-secondary]="compactEmptyState"
>
  <div class="upload-document-container__header" *ngIf="!hideHeading">
    <h5 class="m-0 fw-bold font-size-13 text-muted">{{ heading }}</h5>
    <div class="d-flex align-items-center gap-2 flex-shrink-0">
      <div *ngIf="showOrderedCheckbox" class="m-0">
      <label class="form-check-label me-2" for="ordered-input">Ordered</label>
      <input
        class="form-check-input"
        type="checkbox"
        name="ordered-input"
        id="ordered-input"
        (change)="onOrderPlacedChange()"
        [(ngModel)]="labInfo.isOrderPlaced"
      />
      </div>
    </div>
  </div>
  <div class="upload-document-container__body">
    <ng-container
      *ngIf="
        showOrderedCheckbox && labInfo.isOrderPlaced;
        else documentUploadPanel
      "
    >
      <app-lab-ordered-view [labInfo]="labInfo"></app-lab-ordered-view>
    </ng-container>
    <ng-template #documentUploadPanel>
      <ng-container
        *ngIf="!patientDoc?.fileLink || errorFound; else docDetails"
      >
        <file-upload [control]="control" class="lab-test-upload-container">
          <ng-template
            let-isFileDragDropAvailable="isFileDragDropAvailable"
            #placeholder
          >
            <div
              *ngIf="control.size === 0"
              class="d-flex flex-column justify-content-between align-items-center"
              [class.upload-empty-placeholder--compact]="compactEmptyState"
            >
              <ng-container *ngIf="compactEmptyState; else defaultUploadPlaceholder">
                <div class="upload-empty-secondary">
                  <i
                    class="fa-solid fa-plus upload-empty-secondary__plus"
                    aria-hidden="true"
                  ></i>
                  <span class="upload-empty-secondary__label"
                    >Upload Secondary Insurance</span
                  >
                </div>
              </ng-container>
              <ng-template #defaultUploadPlaceholder>
                <img
                  role="button"
                  src="assets/images/custom/file.png"
                  height="28"
                />
                <ng-container
                  *ngIf="isFileDragDropAvailable; else isNotDragDropAvailable"
                >
                  <span class="drag-drop-msg fs-6"
                    >Drag and drop file to
                    <span class="drag-drop-upload-text">upload</span></span
                  >
                </ng-container>
                <ng-template #isNotDragDropAvailable>
                  <span class="text-center mt-1 text-nowrap"
                    >Click here to upload</span
                  >
                </ng-template>
              </ng-template>
            </div>
          </ng-template>

          <ng-template
            let-i="index"
            let-file="file"
            let-control="control"
            #item
          >
            <div class="uploaded-file-info" *ngIf="!isAnalyzing">
              <div class="me-2 uploaded-file-thumb">
                <img
                  *ngIf="pendingUploadPreviewSafeUrl; else pdfDocPendingIcon"
                  class="uploaded-file-thumb__image"
                  [src]="pendingUploadPreviewSafeUrl"
                  alt=""
                />
                <ng-template #pdfDocPendingIcon>
                  <img
                    role="presentation"
                    class="uploaded-file-thumb__pdf"
                    src="assets/images/custom/pdf-doc.png"
                    alt=""
                  />
                </ng-template>
              </div>
              <span class="text-start me-2 flex-grow-1">{{ file.name }}</span>
              <button
                type="button"
                class="btn tertiary-button square pink-bg"
                (click)="control.removeFile(file)"
              >
                <i class="fa-solid fa-xmark fs-5 text-danger"></i>
              </button>
            </div>

            <ng-container *ngIf="isAnalyzing">
              <div class="loader-div">
                <div class="text-center">
                  <img
                    src="/assets/images/custom/loader.gif"
                    width="50px"
                    role="status"
                  />
                </div>
              </div>
            </ng-container>

            <form #patientDocForm="ngForm">
              <div class="d-flex justify-content-end align-items-center">
                <button
                  *ngIf="!isAiFile"
                  [disabled]="isSaving"
                  class="btn tertiary-button"
                  (click)="uploadFile()"
                >
                  <i
                    *ngIf="isSaving"
                    class="fa-duotone fa-spinner-third fa-spin fs-5 me-1"
                  ></i>
                  Upload
                </button>

                <button
                  type="button"
                  *ngIf="isAiFile && !isAnalyzing"
                  class="btn tertiary-button"
                  (click)="importFile()"
                >
                  <i
                    *ngIf="isSaving"
                    class="fa-duotone fa-spinner-third fa-spin fs-5 me-1"
                  ></i>
                  Import
                </button>
              </div>
            </form>
          </ng-template>
        </file-upload>
      </ng-container>

      <ng-template #docDetails>
        <div
          class="document-details"
          role="button"
          tabindex="0"
          title="View document"
          (click)="openDocumentViewModal()"
          (keydown.enter)="openDocumentViewModal()"
          (keydown.space)="$event.preventDefault(); openDocumentViewModal()"
        >
          <div
            class="document-details__action d-flex align-items-center justify-content-end gap-2"
            (click)="$event.stopPropagation()"
          >
            <span
              *ngIf="showOcrStatus && isPhotoIdOcrRunning"
              class="photo-id-ocr-loader text-muted"
              title="Reading document…"
              aria-label="Reading document"
            >
              <i class="fa-duotone fa-spinner-third fa-spin"></i>
            </span>
            <span
              *ngIf="showOcrStatus && !isPhotoIdOcrRunning"
              class="photo-id-ocr-icons d-inline-flex align-items-center gap-1 flex-shrink-0"
            >
              <i
                *ngIf="photoIdMatchesEncounterDemographics"
                class="fa-solid fa-circle-check photo-id-demographics-check"
                title="Name and DOB match patient demographics"
                aria-label="Matches patient demographics"
              ></i>
              <i
                *ngIf="photoIdDemographicsMismatchWarning"
                class="fa-solid fa-triangle-exclamation photo-id-demographics-warning"
                title="Name or DOB does not match patient demographics"
                aria-label="Does not match patient demographics"
                role="button"
                (click)="openPhotoIdDemographicsUpdateModal($event)"
              ></i>
              <img
                *ngIf="showOcrBlueIcon"
                src="assets/images/custom/ocr_blue.svg"
                alt=""
                class="photo-id-ocr-status-icon"
                title="Document read with OCR"
                width="20"
                height="20"
              />
              <img
                *ngIf="!showOcrBlueIcon"
                src="assets/images/custom/ocr_grey.svg"
                alt=""
                class="photo-id-ocr-status-icon"
                title="OCR"
                width="20"
                height="20"
              />
            </span>
            <div class="btn-group" dropdown container="body">
              <i
                class="fa-solid fa-ellipsis-vertical dropdown-toggle ellipsis-btn"
                role="button"
                dropdownToggle
                data-toggle="dropdown"
                aria-expanded="true"
              ></i>
              <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
                <span
                  class="dropdown-item"
                  role="button"
                  (click)="openDocumentViewModal()"
                  >View</span
                >
                <span
                  class="dropdown-item"
                  role="button"
                  (click)="removePatientDoc()"
                  >Delete</span
                >
              </div>
            </div>
          </div>
          <div class="document-details__body">
            <img
              *ngIf="savedDocThumbnailSafeUrl; else savedDocPdfIcon"
              class="document-details__body--icon document-details__body--thumb"
              [src]="savedDocThumbnailSafeUrl"
              alt=""
            />
            <ng-template #savedDocPdfIcon>
              <img
                class="document-details__body--icon"
                src="assets/images/custom/pdf-doc.png"
                alt=""
              />
            </ng-template>
            <div class="flex-grow-1 min-w-0">
              <span
                *ngIf="
                  documentType === UploadDocumentType.Identification &&
                  photoIdOcrSummaryVisible
                "
                class="document-details__info--name document-details__info--photo-id-ocr"
              >
                <span
                  *ngIf="photoIdDisplayNameFormatted"
                  class="document-details__info--photo-id-name"
                  >{{ photoIdDisplayNameFormatted }}</span
                >
                <span
                  *ngIf="photoIdMetadataDobDisplay"
                  class="document-details__info--photo-id-dob"
                  >DOB: {{ photoIdMetadataDobDisplay }}</span
                >
              </span>
              <span
                *ngIf="
                  insuranceTwoLineBlockVisible &&
                  !(
                    documentType === UploadDocumentType.Identification &&
                    photoIdOcrSummaryVisible
                  )
                "
                class="document-details__info--name document-details__info--insurance-ocr"
              >
                <span
                  *ngIf="insuranceNameLineDisplay"
                  class="document-details__info--insurance-name"
                  [title]="insuranceNameLineDisplay"
                  >{{ insuranceNameLineDisplay }}</span
                >
                <!-- <span
                  *ngIf="insurancePayerCodeLine"
                  class="document-details__info--insurance-payer-code"
                  >Payer ID: {{ insurancePayerCodeLine }}</span
                > -->
              </span>
              <span
                *ngIf="
                  !(
                    documentType === UploadDocumentType.Identification &&
                    photoIdOcrSummaryVisible
                  ) && !insuranceTwoLineBlockVisible
                "
                class="document-details__info--name"
                >{{ patientDoc?.name }}</span
              >
              <span class="document-details__info--date"
                >{{ documentUpdatedByDisplay }}
                {{ patientDoc?.createdAt | date : "mediumDate" }}</span
              >
            </div>
          </div>
          <p *ngIf="showOldEncounterWarning" class="encounter-warning">
            <i class="fa-solid fa-exclamation-triangle me-1"></i>
            Encounter older then 30 days
          </p>
        </div>
      </ng-template>

      <ng-container *ngIf="errorFound">
        <div class="err-section mt-n1">
          <p class="err-msg">
            <i class="fa fa-exclamation-triangle me-1"></i>
            {{ errorMsg }}
          </p>
        </div>
      </ng-container>
    </ng-template>
  </div>
</div>
